import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UserSubscriptionMixin } from 'src/app/mixins/subscriptions.mixin';
import { ClientService } from 'src/app/services/client.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ProjectService } from 'src/app/services/project.service';
import { UserService } from 'src/app/services/user.service';
import ProjectSettings from 'src/app/interfaces/project-settings';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { PageScrollService } from 'ngx-page-scroll-core';
import { LoadingService } from 'src/app/services/loading.service';
import { ClientModel } from 'src/app/models/client.model';
import ClientPortal from 'src/app/interfaces/client-portal';


@Component({
  selector: 'app-project-settings',
  templateUrl: './project-settings.component.html',
  styleUrls: ['./project-settings.component.scss']
})
export class ProjectSettingsComponent extends UserSubscriptionMixin implements OnInit {
  @ViewChild('currentProjectClientDropdownBtn') currentProjectClientDropdownBtn;
  currentFilter = null;
  filteredClients = [];
  clientSearch = {
    newProject: '',
    currentProject: '',
    editClients: ''
  }
  clientPortal: ClientPortal | undefined = {
      guidelines: {},
      logos: {},
      colors: {},
      fonts: {},
      iconsGraphics: {},
      links: {}
  };

  colorSlugs = {};
  designModules = ['colors', 'typography', 'spacing', 'buttons', 'links'];
  devModules = ['overview', 'codeBlocks', 'components', 'stylesheet'];

  constructor(
    userService: UserService,
    navService: NavigationService,
    projectService: ProjectService,
    clientService: ClientService,
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private pageScrollService: PageScrollService,
    @Inject(DOCUMENT) private document: any
  ) {
    super(userService, navService, projectService, clientService);
  }

  ngOnInit(): void {

    this.currentProjectLoaded.then(() => {

      if (!this.currentProject.settings) {
        this.currentProject.settings = {
          url: '',
          isLive: false
        } as ProjectSettings;
      } else {
        if (!('url' in this.currentProject.settings)) this.currentProject.settings.url = '';
        if (!('isLive' in this.currentProject.settings)) this.currentProject.settings.isLive = false;
      }

      if (!this.currentProject.settings.thumbnail) {
        this.currentProject.settings.thumbnail = [{}, {}, {}];
        this.projectService.updateProject(this.currentProject.id, this.currentProject);
      }
      if (!this.currentProject.settings.colors.headerBG || !this.currentProject.settings.colors.headerText) {
        this.currentProject.settings.colors.headerBG = 'neutral-darker';
        this.currentProject.settings.colors.headerText = 'neutral-darker';
        if (this.currentProject.settings.colors.header) {
          delete this.currentProject.settings.colors.header;
          this.projectService.updateProject(this.currentProject.id, this.currentProject);
        }
      }
      this.setColorSlugs();

      if (!this.currentProject.settings.icon) {
        this.currentProject.settings.icon = false;
        this.updateProject();
      }
      if (!this.currentProject.settings.iconBg) {
        this.currentProject.settings.iconBg = this.currentProject.variables.colors[0];
        this.updateProject();
      }

      if (!('clientPortal' in this.currentProject)) {
        this.currentProject.clientPortal = { ...this.clientPortal }

      }
      return this.clientsLoaded;
    }).then(() => {
      this.initClients();
    })
  }

  updateProject() {
    this.loadingService.startLoading();
    this.projectService.updateProject(this.currentProject.id, this.currentProject).then(res => {
      this.loadingService.stopLoading();
      console.log(res);
    });
  }

  /************************** 
  * Settings
  * ************************/
  toggleModule(m, type) {
    this.currentProject.settings.modules[type][m] = !this.currentProject.settings.modules[type][m];
  }

  setThumbnailColor(slug, i) {
    this.currentProject.settings.thumbnail[i] = this.currentProject.variables.colors.filter(c => c.slug === slug)[0];
  }

  setIconColor(slug) {
    this.currentProject.settings.iconBg = this.currentProject.variables.colors.filter(c => c.slug === slug)[0];
  }

  /************************** 
   * Clients
   * ************************/
  initClients() {
    this.filteredClients = this.clients.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });
    let currentClient = this.clients.filter(c => {
      return c.id === this.currentProject.client;
    })[0]
    if (currentClient) this.clientSearch.currentProject = currentClient.name;
  }

  onClientSearch(location) {
    if (this.clientSearch[location].length > 0) {
      let a = this[location + 'ClientDropdownBtn'].nativeElement.parentNode;
      if (a.nextElementSibling.classList.contains('hide-fully')) a.click();
    }
    this.filteredClients = this.clients.filter(c => {
      return c.name.toLowerCase().includes(this.clientSearch[location].toLowerCase());
    })
  }

  selectClient(location, data) {
    this.clientSearch[location] = data.name;
    this[location].client = data.id;
  }

  createClient(location) {
    this.loadingService.startLoading();
    let newClient = { ...ClientModel };
    newClient.name = this.clientSearch[location];
    newClient.owner = this.currentUser.id;
    this.clientService.createClient(newClient).then(id => {
      if (location !== 'editClients') this[location].client = id;
      if (location == 'editClients') this.clientSearch[location] = '';
      this.loadingService.stopLoading();
    })
  }

  removeClient(location) {
    this[location].client = null;
    this.clientSearch[location] = '';
  }

  deleteClient(i) {
    this.loadingService.startLoading();
    this.clientService.deleteClient(this.clients[i].id).then(() => {
      this.loadingService.stopLoading();
    })
  }
  updateClient(i) {
    this.loadingService.startLoading();
    this.clientService.updateClient(this.clients[i].id, this.clients[i]).then(() => {
      this.loadingService.stopLoading();
    })
  }

  setFilter(clientID) {
    if (!clientID || this.currentFilter === clientID) {
      if (this.router.url.includes('code-blocks')) this.router.navigateByUrl('/');
      this.currentFilter = null;
      this.projectService.filterByClient(null);
    } else if (clientID === 'codeBlocks') {
      this.currentFilter = 'codeBlocks';
      this.router.navigateByUrl('/code-blocks')
    } else {
      if (this.router.url.includes('code-blocks')) this.router.navigateByUrl('/');
      this.currentFilter = clientID;
      this.projectService.filterByClient(clientID)
    }
  }

  /**************************
  * Utilities
  * ************************/
  convertToNormalCase(str) {
    return str.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); })
  }
  toKebabCase(str) {
    return str && str
      .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
      .map(x => x.toLowerCase())
      .join('-');
  }

  setColorSlugs() {
    for (let color of this.currentProject.variables.colors) {
      this.colorSlugs[color.slug] = color.hex;
    }
  }
}
